module.exports = __webpack_public_path__ + "static/agency_3-cc36558cf17cd7772922215a47e56fd7.svg";